import ShopScreenshot from './ShopScreenshot';

export * from './ShopScreenshot';
export default ShopScreenshot;
